// extracted by mini-css-extract-plugin
export var blue = "bc_fd";
export var button = "bc_cq";
export var label = "bc_cb";
export var orange = "bc_ff";
export var white = "bc_fg";